export enum JobProcessingStatus {
    Queued = 'Queued',
    Executing = 'Executing',
    Completed = 'Completed',
    Failed = 'Failed',
    Cancelled = 'Cancelled'
}
